export { ReviewStars, type IReviewStarsProps } from './review-stars';
